export const creators = [
  {
    name: '小林vlog',
    avatar: 'https://readdy.ai/api/search-image?query=A%20young%20Asian%20woman%20portrait%20with%20warm%20smile%2C%20minimal%20studio%20lighting%2C%20soft%20coral%20background%2C%20professional%20headshot%20style%2C%20clean%20and%20natural%20look&width=200&height=200&seq=creator-avatar-1&orientation=squarish',
    followers: '52万',
    category: '生活Vlog',
    description: '用镜头记录美好生活的每一刻',
    achievement: '月播放量超500万，品牌合作月收入3万+',
  },
  {
    name: '美食家老王',
    avatar: 'https://readdy.ai/api/search-image?query=A%20middle-aged%20Asian%20man%20portrait%20with%20friendly%20expression%2C%20chef%20style%2C%20warm%20studio%20lighting%2C%20soft%20cream%20background%2C%20professional%20headshot&width=200&height=200&seq=creator-avatar-2&orientation=squarish',
    followers: '38万',
    category: '美食制作',
    description: '专注家常美食教程，让每个人都能成为厨房达人',
    achievement: '单条视频最高播放量1200万，带货月销售额10万+',
  },
  {
    name: '科技小宇',
    avatar: 'https://readdy.ai/api/search-image?query=A%20young%20Asian%20man%20portrait%20with%20modern%20stylish%20look%2C%20tech%20enthusiast%20vibe%2C%20warm%20studio%20lighting%2C%20soft%20coral%20background%2C%20professional%20headshot&width=200&height=200&seq=creator-avatar-3&orientation=squarish',
    followers: '65万',
    category: '数码评测',
    description: '用最通俗的语言讲最专业的数码知识',
    achievement: '年度最佳科技创作者，月收入5万+',
  },
  {
    name: '舞蹈达人Lily',
    avatar: 'https://readdy.ai/api/search-image?query=A%20young%20Asian%20woman%20portrait%20with%20elegant%20artistic%20expression%2C%20dancer%20style%2C%20warm%20studio%20lighting%2C%20soft%20cream%20background%2C%20graceful%20headshot&width=200&height=200&seq=creator-avatar-4&orientation=squarish',
    followers: '120万',
    category: '舞蹈表演',
    description: '舞蹈是生活的另一种语言',
    achievement: '平台头部舞蹈创作者，品牌代言年收入百万级',
  },
];